

import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React from "react";
const Submission = () => {
    return (
        <>
            <iframe
                       height="100%"
                       style={{ width: "100%" }}
                       scrolling="no"
                       title="Iframe"
                       id="dashboardFrame"
                       src={
                         //getFormattedURL(dashboardURLConfig[domain]?.[activeKey]) ||
                         "https://analytics.zoho.in/open-view/103074000045008503/a5e6f60beda02732ec849d1fadab3db0"
                       }
                     ></iframe>
        </>
    )
};
export default Submission;


